/* eslint-disable react/jsx-pascal-case */
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  default as Apply_Modal,
  default as Apply_Modal2,
} from "../Component/Apply_Modal";
import Privacy_Modal from "../Component/Privacy_Modal";
import Privacy_Policy_Modal from "../Component/Privacy_Policy_Modal";
import Terms_Modal from "../Component/Terms_Modal";
import theme, { Content_Text } from "../Component/theme";
import Header_Main from "./Header_Main";
import ic_plus from "../image/ic_plus_black.png";
import ic_red_dot from "../image/ic_red_dot.png";
import ic_X from "../image/ic_X_gray.png";
import img_call from "../image/img_call.png";
import Footer_FMS from "../2.FMS/Footer_FMS";
import Side_Main from "./Side_Main";

const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main"
    "footer footer footer";
  grid-template-rows: 80px 1fr 400px;
  grid-template-columns: 200px 1fr 200px;
  @media (max-width: 800px) {
    grid-template-rows: 40px 1fr 400px;
  }
`;
const Header = styled.header`
  grid-area: header;
  background: white;
  display: flex;
  align-items: center;
  border-width: 0px 0px 1px 0px;
  border-color: #f1f1f1;
  border-style: solid;
  justify-content: center;
  position: fixed;
  width: 100%;
  z-index: 10;
  @media (max-width: 800px) {
    padding-left: 15px;
  }
`;
const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
`;
const Main = styled.main`
  grid-area: main;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10px;
  background-color: white;
`;
const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 50px;
`;
const Main_init_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
`;
const Main_Content = styled.div`
  flex: 1;
  display: grid;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;

const Main_init_div3 = styled.div`
  display: flex;
  width: 200px;
  padding: 8px;
  border-radius: 16px;
  background-color: #fafafa;
  align-items: center;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 800px) {
    padding: 8px;
    width: 130px;
  }
`;

const Main_Content2 = styled.div`
  flex: 1;
  display: flex;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 800px) {
    padding: 0px 2px 0px 2px;
  }
`;

const Row_div = styled.div`
  display: flex;
  width: 980px;
  @media (max-width: 800px) {
    flex-direction: column; /* 모바일 화면에서는 열 방향 */
    width: 90%;
  }
`;
const Border_div = styled.div`
  width: 50%;
  height: 500px;
  display: grid;
  padding: 30px;
  align-self: center;
  border-width: 4px;
  border-style: solid;
  border-radius: 14px;
  margin-right: ${(props) => (props.$num === "1" ? 20 : 0)}px;
  border-color: ${(props) =>
    props.$num === "1" ? theme.colors.fontEmerald : theme.colors.fontBlue};
  white-space: pre-line;

  @media (max-width: 800px) {
    width: 90%;
    margin-bottom: 15px;
    margin-right: 0px;
    height: 300px;
  }
`;
const Grid_div = styled.div`
  display: grid;
  height: 0px;
`;

const Main_Button = styled.button`
  background-color: ${(props) =>
    props.$num === "1" ? theme.colors.fontEmerald : theme.colors.fontBlue};
  width: 98px;
  height: 40px;
  padding: 10px 20px;
  border-radius: 100px;
  border-width: 0px;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  justify-self: center;
  display: flex;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: ${(props) =>
      props.$num === "1" ? "#3BB8A3" : "#377AA6"};
  }
`;
const Footer = styled.footer`
  grid-area: footer;
  background: #464646;
  color: white;
  display: grid;
  align-items: flex-start;
  justify-content: center;
  white-space: pre-line;
  text-align: center;
`;
const Footer_Text = styled(Content_Text)`
  margin-top: 5px;
`;

const Select_Button = styled.button`
  background-color: ${(props) => (props.$select ? "white" : "#FAFAFA")};
  padding: 6px 0px;
  width: 100%;
  border-radius: 8px;
  border-style: solid;
  border-width: ${(props) => (props.$select ? 1 : 0)}px;
  border-color: ${theme.colors.fontBlue};
  @media (max-width: 800px) {
    padding: 4px 0px;
  }
  cursor: pointer;
`;

const Select_Button2 = styled.button`
  margin-top: 8px;
  margin-right: 10px;
  background-color: white;
  padding: 6px 0px;
  width: 76px;
  border-radius: 6px;
  border-style: solid;
  border-width: 1px;
  border-color: ${(props) =>
    props.$select ? theme.colors.fontBlue : theme.colors.barGray};
  @media (max-width: 800px) {
    padding: 4px 0px;
    width: 55px;
  }
  cursor: pointer;
`;

const Call_View = styled.div``;

const TitleDiv = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
`;
const NameInput = styled.input`
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: ${theme.colors.barGray};
  width: 600px;
  margin-top: 10px;
  padding: 8px 5px;
  @media (max-width: 800px) {
    width: 98%;
  }
`;

const PhoneInput = styled.input`
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: ${theme.colors.barGray};
  width: 10%;
  margin-top: 10px;
  padding: 8px 5px;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
const PayInput = styled.input`
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: ${theme.colors.barGray};
  width: 600px;
  margin-top: 10px;
  padding: 8px 5px;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  @media (max-width: 800px) {
    width: 98%;
  }
`;

const PayList = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
`;

const PaySelect = styled.div`
  display: flex;
  padding: 5px 0px;
  align-items: center;
`;

const MemoInput = styled.textarea`
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: ${theme.colors.barGray};
  height: 100px;
  width: 96%;
  margin-top: 10px;
  padding: 10px;
  resize: none;
`;
const CheckBox = styled.input`
  appearance: none;
  border: 1.5px solid ${theme.colors.barGray};
  border-radius: 100px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: relative;
  margin-right: 10px;

  &:checked::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px; /* 내부 원의 크기 */
    height: 12px; /* 내부 원의 크기 */
    background-color: ${theme.colors.fontBlue};
    border-radius: 100px;
  }
`;

const CheckBox2 = styled.input`
  appearance: none;
  border: 1.5px solid ${theme.colors.barGray};
  border-radius: 100px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: relative;
  margin-right: 10px;

  &:checked::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    background-color: ${theme.colors.fontBlue};
    border-radius: 100px;
  }
`;
const AboutFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: flex-end;
  padding-top: 22px;
`;
const Button = styled.button`
  background-color: ${(props) =>
    props.disabled ? theme.colors.barDarkGray : theme.colors.fontBlue};
  color: white;
  padding: 10px 30px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  border-width: 0px;
  border-radius: 8px;
  text-align: center;
  text-justify: center;
  transition: background-color 0.3s ease;
`;

const Add_File = styled.button`
  margin-top: 8px;
  background-color: ${theme.colors.bgGray};
  width: 100%;
  height: 80px;
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
  border-color: ${theme.colors.barGray};
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const File_Box = styled.div`
  margin-top: 10px;
  padding: 7px 10px;
  border-radius: 6px;
  border-color: ${theme.colors.barGray};
  border-width: 1px;
  border-style: solid;
  width: 270px;
  flex-direction: row;
  justify-content: space-between;
  display: flex;
  align-items: center;
`;

const File_Text = styled(Content_Text)`
  overflow: hidden;
  margin-right: 15px;
`;

function About() {
  const [stan_modal, set_Stan_Modal] = useState(false);
  const [pre_modal, set_Pre_Modal] = useState(false);
  const open_Stan_Modal = () => set_Stan_Modal(true);
  const close_Stan_Modal = () => set_Stan_Modal(false);
  const open_Pre_Modal = () => set_Pre_Modal(true);
  const close_Pre_Modal = () => set_Pre_Modal(false);
  const [privacy_policy, set_Privacy_Policy] = useState(false);
  const [terms, set_Terms] = useState(false);
  const close_privacy_policy = () => set_Privacy_Policy(false);
  const close_terms = () => set_Terms(false);
  const [select, set_Select] = useState("앱/웹");
  const [name, set_Name] = useState("");
  const [phone_f, set_Phone_f] = useState("");
  const [phone_s, set_Phone_s] = useState("");
  const [phone_t, set_Phone_t] = useState("");
  const [email, set_Email] = useState("");
  const [memo, set_Memo] = useState("");
  const [pay, set_Pay] = useState(0);
  const [pay_list, set_Pay_liset] = useState([
    "1,500만원 이하",
    "1,500 ~ 3,000만원",
    "3,000 ~ 5,000만원",
    "5,000만원 이상",
  ]);
  const [check, set_Check] = useState(false);
  const [modal, set_Modal] = useState(false);
  const [type, set_Type] = useState(["앱"]);
  const [reference, set_Reference] = useState("");
  const [file_name_list, set_File_Name_List] = useState([]);
  const [file_list, set_File_List] = useState([]);
  const [file_img_list, set_File_IMG_List] = useState([]);
  const [loading, set_Loading] = useState(false);

  const name_set = (event) => {
    set_Name(event.target.value);
  };
  const phone_f_set = (event) => {
    if (event.target.value.length < 4) {
      set_Phone_f(event.target.value);
    }
  };
  const phone_s_set = (event) => {
    if (event.target.value.length < 5) {
      set_Phone_s(event.target.value);
    }
  };
  const phone_t_set = (event) => {
    if (event.target.value.length < 5) {
      set_Phone_t(event.target.value);
    }
  };
  const email_set = (event) => {
    set_Email(event.target.value);
  };
  const memo_set = (event) => {
    set_Memo(event.target.value);
  };
  const pay_set = (num) => {
    set_Pay(num);
  };
  const ref_set = (event) => {
    set_Reference(event.target.value);
  };
  const open_Modal = () => {
    set_Modal(true);
  };
  const close_Modal = () => {
    set_Modal(false);
  };
  const Type_Set = (item) => {
    type.includes(item)
      ? set_Type(type.filter((i) => i !== item))
      : set_Type([...type, item]);
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const location = useLocation();
  useEffect(() => {
    const data = location.state;
    if (data && data !== undefined) {
      if (data.data !== undefined) {
        set_Select(data.data);
      }
    } else {
      set_Select("앱/웹");
    }
    // 사이즈 체크

    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 우클릭 금지
  useEffect(() => {
    const handleRightClick = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  const send_mail = () => {
    if (!check) {
      alert("개인정보 수집 및 이용 동의에 동의해주세요.");
    } else if (
      name === "" ||
      phone_f === "" ||
      phone_s === "" ||
      phone_t === "" ||
      email === "" ||
      type.length === 0
    ) {
      alert("필수 입력 항목을 입력해주세요.");
    } else if (
      (email !== "" && !email.includes("@")) ||
      (email !== "" && !email.includes("."))
    ) {
      alert("이메일 주소를 확인해주세요.");
    } else {
      set_Loading(true);
      axios
        .post(
          "http://linkfms.kr/FMS/outsourcing_system.php",
          {
            name: name,
            phone: phone_f + "-" + phone_s + "-" + phone_t,
            user_email: email,
            service_type: type[0] + "," + type[1],
            project_budget: pay_list[pay],
            reference: reference,
            project_content: memo,
            file: file_list[0],
            file1: file_list[1],
            file2: file_list[2],
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then(function () {
          // alert(response.data);
          alert("문의완료. 24시간내로 연락드릴게요!");
          set_Loading(false);
        })
        .catch(function () {
          // console.log(error);
        });
    }
  };

  // 파일 업로드 input 커스텀
  const fileInputRef = useRef(null);

  const handleFileSelect = (event) => {
    const files = event.target.files;
    const maxFileSize = 50 * 1024 * 1024;
    if (files && files.length > 0 && files[0].size > maxFileSize) {
      // 파일 크기가 50MB를 초과할 경우
      alert(
        "파일 크기가 너무 큽니다. 50MB 이하의 파일만 업로드할 수 있습니다."
      );
    } else if (
      files &&
      files.length > 0 &&
      !file_name_list.includes(files[0].name)
    ) {
      set_File_Name_List([...file_name_list, files[0].name]); // 파일 이름 리스트 업데이트
      set_File_List([...file_list, files[0]]); // file_list에는 File 객체를 직접 추가해야 합니다.

      const reader = new FileReader();
      reader.onloadend = () => {
        set_File_IMG_List([...file_img_list, reader.result]); // file_img_list 업데이트
      };
      reader.readAsDataURL(files[0]);
    }
  };

  const Del_File = (data) => {
    const new_name_List = file_name_list.filter(
      (item, index) => index !== data
    );
    const new_List = file_list.filter((item, index) => index !== data);
    const new_IMG_List = file_img_list.filter((item, index) => index !== data);

    set_File_Name_List(new_name_List);
    set_File_List(new_List);
    set_File_IMG_List(new_IMG_List);
  };

  const handleClick = () => {
    // 숨겨진 input 요소를 활성화
    if (file_list.length < 3) {
      fileInputRef.current.click();
    }
  };
  useEffect(() => {
    // STEP 1: wcslog.js 스크립트가 이미 로드된 상태여야 함
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//wcs.naver.net/wcslog.js";
    document.body.appendChild(script);

    script.onload = () => {
      // STEP 2: _nasa 변수에 전환 추적 정보를 담음
      var _nasa = {};
      if (window.wcs) {
        _nasa["cnv"] = window.wcs.cnv("4", "1"); // 결제 금액 변수를 실제 값으로 대체
        window.wcs_do(_nasa);
      }
    };

    // Clean up the script when the component is unmounted
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container width={windowSize.width} height={windowSize.height}>
      <Header>
        <Header_Main page="제작문의" />
      </Header>
      {/* <Sidebar>사이드바 영역</Sidebar> */}
      <Main>
        <Side_Main />
        <Main_div style={{ paddingBottom: 20 }}>
          <Main_init_div>
            <Main_Content>
              <Content_Text $xxlarge $xbold>
                제작문의
              </Content_Text>
            </Main_Content>
          </Main_init_div>
        </Main_div>
        <Main_div style={{ paddingBottom: 20 }}>
          <Main_init_div3>
            <Main_Content2>
              <Select_Button
                $select={select === "앱/웹"}
                onClick={() => {
                  set_Select("앱/웹");
                }}
              >
                <Content_Text $blue={select === "앱/웹"} $lightGray>
                  앱/웹
                </Content_Text>
              </Select_Button>
            </Main_Content2>
            <Main_Content2>
              <Select_Button
                $select={select === "FMS"}
                onClick={() => {
                  set_Select("FMS");
                }}
              >
                <Content_Text $blue={select === "FMS"} $lightGray>
                  FMS
                </Content_Text>
              </Select_Button>
            </Main_Content2>
          </Main_init_div3>
        </Main_div>
        <Main_div style={{ paddingBottom: 0 }}>
          <Call_View>
            <Image
              style={{
                width: 220,
              }}
              src={img_call}
            />
          </Call_View>
        </Main_div>
        <Main_div style={{ paddingBottom: 200 }}>
          <Main_init_div style={{ paddingTop: 20 }}>
            {select === "앱/웹" ? (
              <Main_Content $left style={{ maxWidth: 600 }}>
                <TitleDiv>
                  <Content_Text $xbold $xsmall>
                    이름
                  </Content_Text>
                  <img
                    style={{ height: 5, marginLeft: 5 }}
                    src={ic_red_dot}
                    alt={ic_red_dot}
                  />
                </TitleDiv>
                <NameInput onChange={name_set} value={name} type="text" />
                <TitleDiv>
                  <Content_Text $xbold $xsmall>
                    연락처
                  </Content_Text>
                  <img
                    style={{ height: 5, marginLeft: 5 }}
                    src={ic_red_dot}
                    alt={ic_red_dot}
                  />
                </TitleDiv>
                <div>
                  <PhoneInput
                    onChange={phone_f_set}
                    value={phone_f}
                    type="number"
                  />
                  {" - "}
                  <PhoneInput
                    onChange={phone_s_set}
                    value={phone_s}
                    type="number"
                  />
                  {" - "}
                  <PhoneInput
                    onChange={phone_t_set}
                    value={phone_t}
                    type="number"
                  />
                </div>
                <TitleDiv>
                  <Content_Text $xbold $xsmall>
                    이메일
                  </Content_Text>
                  <img
                    style={{ height: 5, marginLeft: 5 }}
                    src={ic_red_dot}
                    alt={ic_red_dot}
                  />
                </TitleDiv>
                <NameInput onChange={email_set} value={email} type="text" />

                <TitleDiv>
                  <Content_Text $xbold $xsmall>
                    원하는 서비스 종류
                  </Content_Text>
                  <img
                    style={{ height: 5, marginLeft: 5 }}
                    src={ic_red_dot}
                    alt={ic_red_dot}
                  />
                </TitleDiv>
                <div>
                  <Select_Button2
                    $select={type.includes("앱")}
                    onClick={() => {
                      Type_Set("앱");
                    }}
                  >
                    <Content_Text $xsmall $blue={type.includes("앱")} $gray>
                      앱 개발
                    </Content_Text>
                  </Select_Button2>
                  <Select_Button2
                    $select={type.includes("웹")}
                    onClick={() => {
                      Type_Set("웹");
                    }}
                  >
                    <Content_Text $xsmall $blue={type.includes("웹")} $gray>
                      웹 개발
                    </Content_Text>
                  </Select_Button2>
                </div>
                <TitleDiv>
                  <Content_Text $xbold $xsmall>
                    프로젝트 예산
                  </Content_Text>
                </TitleDiv>
                {/* <PayInput onChange={pay_set} value={pay} type="text" /> */}
                <PayList>
                  {pay_list.map((item, index) => {
                    return (
                      <PaySelect key={index}>
                        <CheckBox2
                          type="checkbox"
                          checked={pay === index}
                          onChange={() => {
                            pay_set(index);
                          }}
                        />
                        <Content_Text $xsmall>{item}</Content_Text>
                      </PaySelect>
                    );
                  })}
                </PayList>
                <TitleDiv>
                  <Content_Text $xbold $xsmall>
                    참고 앱 또는 사이트
                  </Content_Text>
                </TitleDiv>
                <NameInput onChange={ref_set} value={reference} type="text" />

                <TitleDiv>
                  <Content_Text $xbold $xsmall>
                    프로젝트 내용
                  </Content_Text>
                </TitleDiv>
                <MemoInput onChange={memo_set} value={memo} type="text" />
                <TitleDiv>
                  <Content_Text $xbold $xsmall>
                    파일첨부 ({file_list.length}/3)
                  </Content_Text>
                </TitleDiv>
                <Add_File onClick={handleClick}>
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileSelect}
                    style={{ display: "none" }}
                  />
                  <Image style={{ width: 152 }} src={ic_plus} alt={ic_plus} />
                </Add_File>
                {file_name_list.map((item, index) => {
                  return (
                    <File_Box key={item}>
                      {/* {(item.split(".")[1] === "jpg" ||
                        item.split(".")[1] === "png" ||
                        item.split(".")[1] === "gif" ||
                        item.split(".")[1] === "jpeg") && (
                        <Image
                          style={{ width: 50 }}
                          src={file_img_list[index]}
                          alt={file_img_list[index]}
                        />
                      )} */}
                      <File_Text $lightGray>{item}</File_Text>
                      <Image
                        onClick={() => {
                          Del_File(index);
                        }}
                        style={{ width: 20, height: 20, cursor: "pointer" }}
                        src={ic_X}
                        alt={ic_X}
                      />
                    </File_Box>
                  );
                })}

                <TitleDiv>
                  <CheckBox
                    type="checkbox"
                    onClick={() => {
                      set_Check(!check);
                    }}
                  />
                  <Content_Text $xsmall $bold>
                    개인정보 수집 및 이용 동의
                  </Content_Text>
                  <Content_Text
                    $xxsmall
                    $lightGray
                    style={{ cursor: "pointer" }}
                    onClick={open_Modal}
                  >
                    [자세히보기]
                  </Content_Text>
                </TitleDiv>
                <AboutFooter>
                  <Button disabled={loading} onClick={send_mail}>
                    제출하기
                  </Button>
                </AboutFooter>
              </Main_Content>
            ) : (
              <Row_div>
                <Border_div $num={"1"}>
                  <Grid_div>
                    <Content_Text $xmlarge $xbold $emerald>
                      Standard
                    </Content_Text>
                    <Footer_Text>
                      링크캠퍼스에서 제공하는 플랫폼을 기본으로 하여 유지보수와
                      서버비를 포함하는 FMS입니다.
                    </Footer_Text>
                    <Content_Text $xmlarge $xbold style={{ marginTop: 30 }}>
                      100,000원 ~{" "}
                    </Content_Text>
                    <Footer_Text $small $gray>
                      월별, 시설 1개당
                    </Footer_Text>
                  </Grid_div>
                  <Main_Button $num={"1"} onClick={open_Stan_Modal}>
                    <Content_Text $white $bold $xsmall>
                      신청하기
                    </Content_Text>
                  </Main_Button>
                </Border_div>
                <Border_div>
                  <Grid_div>
                    <Content_Text $xmlarge $xbold $blue>
                      Premium
                    </Content_Text>
                    <Footer_Text>
                      별도 제작이 필요한 FMS로 구축비용과 유지보수 및 서버비를
                      포함하는 FMS입니다.
                    </Footer_Text>
                    <Content_Text $xmlarge $xbold style={{ marginTop: 30 }}>
                      별도 문의
                    </Content_Text>
                    <Footer_Text $small $gray>
                      월별, 시설 1개당
                    </Footer_Text>
                  </Grid_div>
                  <Main_Button onClick={open_Pre_Modal}>
                    <Content_Text $white $bold $xsmall>
                      신청하기
                    </Content_Text>
                  </Main_Button>
                </Border_div>
              </Row_div>
            )}
          </Main_init_div>
        </Main_div>
      </Main>
      <Footer>
        <Footer_FMS />
      </Footer>
      <Privacy_Policy_Modal
        show={privacy_policy}
        onClose={close_privacy_policy}
      />
      <Terms_Modal show={terms} onClose={close_terms} />
      <Apply_Modal show={stan_modal} onClose={close_Stan_Modal} data={"stan"} />
      <Apply_Modal2 show={pre_modal} onClose={close_Pre_Modal} data={"pre"} />
      <Privacy_Modal show={modal} onClose={close_Modal} />
    </Container>
  );
}

export default About;
